import React from 'react'
import { HomeBanner } from '../../Components/Home/HomeBanner'
import "./home.css"
import { TrustedClients } from '../../Components/Home/TrustedClients'
import BusinessSection from '../../Components/Home/BusinessSection'
import BeneficialElements from '../../Components/Home/BeneficialCards'
import BusinessISO from '../../Components/Home/BusinessIso'
import WhyChooseUs from '../../Components/Home/WhyChooseUs'
import ServicesWeOffer from '../../Components/Home/ServicesWeOffer'
import ElevateYourBusiness from '../../Components/Home/ElevateYourBusiness'
import HomeServices from '../../Components/Home/HomeServices'
export const HomePage = () => {
  return (
    <div>
        <HomeBanner/>
        <TrustedClients/>
        <BusinessSection/>
        <BeneficialElements/>
        <BusinessISO/>
        <WhyChooseUs/>
        <ServicesWeOffer/>
        <ElevateYourBusiness/>
        <HomeServices/>
    </div>
  )
}
